module.exports = __webpack_public_path__ + "e3d2f764e04da706f73725a096924801.svg";